<template>
    <v-dialog v-model="dOpenComponent" persistent full-width @keydown.esc="fCerrarVentana()" @keydown.enter="fBuscar()">
        <v-card>
            <!-- cabecera del dialogo -->
            <v-toolbar dark class="datModalTitleContainer">
                <v-toolbar-title>
                    {{ dInformeComponente.nombre }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon dark @click="fCerrarVentana()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-dialog v-if="dOpenComponent" v-model="dLoading" hide-overlay persistent width="300">
                <v-card class="datModalTitleContainer" dark>
                    <v-card-text>
                        {{ $t('cargandoContenido') }}
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-form ref="form" lazy-dValidation>
                <v-card-text>
                    <div class="subheading font-weight-bold mt-2 mb-2 px-3">{{ dInformeComponente.descripcion }}</div>
                </v-card-text>
                <!-- Filtro de cabecera -->
                <v-layout row wrap>
                    <v-flex xs12 ml-3 mr-3>
                        <v-flex md6 px-2>
                            <v-text-field v-model="dDatosFiltros.search" ref="search" clearable @keydown.tab="fBuscar()"
                                :label="$t('buscarArt')"></v-text-field>
                        </v-flex>
                        <v-flex xs12 text-xs-right>
                            <v-btn @click="fBuscar()" class="datSecondaryBtn" small flat tile>{{
                                $t('buscar') }}</v-btn>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <!-- Detalle -->
                <v-flex>
                    <v-layout row wrap>
                        <v-flex text-xs-center class="mb-3">
                            <v-data-table item-key="articulo" :loading="dLoading" single-expand
                                :no-results-text="this.$t('noResultados')" :no-data-text="this.$t('noResultados')"
                                :rows-per-page-text="$t('numRegPagina')" v-bind:pagination.sync="dPaginationArt"
                                :total-items="dTotalItems" class="tablePedidos"
                                :rows-per-page-items="dRowsPerPageItemsArt" :items="dDatosTabla"
                                :headers="dHeadersTable">
                                <template slot="headers" slot-scope="props">
                                    <tr class="lightPrimaryColorBackground">
                                        <th class="text-xs-center" v-for="header in props.headers" :key="header.key"
                                            :id="header.value"
                                            :class="['column sortable', dPaginationArt.descending ? 'desc' : 'asc', header.value === dPaginationArt.sortBy ? 'active' : header.class, 'text-xs-' + header.align + ' ' + header.class + ' ']"
                                            @click="fCambiaOrden(header, dPaginationArt)">
                                            <v-icon v-if="header.sortable">arrow_upward</v-icon>
                                            {{ header.text }}
                                        </th>
                                    </tr>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td class="text-xs-center ellipsis" @click="fGetLotesArticulos(props)">
                                            <v-icon class="cursorPointer" :class="props.expanded ? 'iconRotate' : ''">
                                                arrow_downward
                                            </v-icon>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <v-progress-linear indeterminate color="black" v-if="!props.item.imagen"
                                                class="mb-0">
                                            </v-progress-linear>
                                            <div v-if="props.item.imagen">
                                                <span v-if="props.item.imagen === '-'">
                                                    -
                                                </span>
                                                <span v-if="props.item.imagen !== '-'">
                                                    <img :src="props.item.imagen" :alt="'img_' + props.item.articulo"
                                                        style="width: 50px; height: 50px; object-fit: contain; cursor: pointer;"
                                                        @click="fMostrarImagenGrande(props.item.imagen)">
                                                </span>
                                            </div>
                                        </td>
                                        <td class="ellipsis" style="padding: 0;">
                                            <span>{{ props.item.articulo }}</span>
                                        </td>
                                        <td class="text-xs-left ellipsis">
                                            <span>{{ props.item.denominacion }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.stockDisponible }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.unidadMedida }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.stockPotencial }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.fechaOC }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.cantidadOC }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.unidadMedidaOC }}</span>
                                        </td>
                                    </tr>
                                </template>
                                <template slot="expand" slot-scope="props">
                                    <!-- DETALLE DE LOTES -->
                                    <v-data-table :headers="dHeadersSubArtTabla" :items="dSubArtDatosTabla"
                                        :loading="dLoading" :pagination.sync="dPaginationSubArt"
                                        :rows-per-page-text="$t('numRegPagina')" :total-items="dTotalSubArtItems"
                                        :rows-per-page-items="dRowsPerPageItemsSubArt" class="subtitle-2" dense>
                                        <!-- Headers personalizados para la subtabla -->
                                        <template slot="headers" slot-scope="props">
                                            <tr class="lighterPrimaryColorBackground">
                                                <th class="text-xs-center" v-for="header in props.headers"
                                                    :key="header.key" :id="header.value" :class="[
                                                        'column',
                                                        header.value === dPaginationSubArt.sortBy ? (dPaginationSubArt.descending ? 'desc' : 'asc') : '',
                                                        'text-xs-' + header.align,
                                                        header.class
                                                    ]" @click="() => { }">
                                                    {{ header.text }}
                                                </th>
                                            </tr>
                                        </template>

                                        <template slot="items" slot-scope="{ item }">
                                            <tr>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.almacen }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.ubicacion }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.lote }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.cantidadLote }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.unidadMedida }}</span>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                    <!-- DETALLE DE OC-->
                                    <v-data-table :headers="dHeadersSubArtOcTabla" :items="dSubArtOcDatosTabla"
                                        :loading="dLoading" :pagination.sync="dPaginationSubArtOc"
                                        :rows-per-page-text="$t('numRegPagina')" :total-items="dTotalSubArtOcItems"
                                        :rows-per-page-items="dRowsPerPageItemsSubArtOc" class="subtitle-2" dense>
                                        <!-- Headers personalizados para la subtabla -->
                                        <template slot="headers" slot-scope="props">
                                            <tr class="lighterPrimaryColorBackground">
                                                <th class="text-xs-center" v-for="header in props.headers"
                                                    :key="header.key" :id="header.value" :class="[
                                                        'column',
                                                        header.value === dPaginationSubArtOc.sortBy ? (dPaginationSubArtOc.descending ? 'desc' : 'asc') : '',
                                                        'text-xs-' + header.align,
                                                        header.class
                                                    ]" @click="() => { }">
                                                    {{ header.text }}
                                                </th>
                                            </tr>
                                        </template>

                                        <template slot="items" slot-scope="{ item }">
                                            <tr>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.ordenCompra }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.fechaEntrega }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.cantidadPedida }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.unidadMedidaUMP }}</span>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>
        </v-card>

        <!-- Diálogo para mostrar imagen en grande -->
        <v-dialog v-model="dMostrarImagen" max-width="800">
            <v-card>
                <v-card-title class="headline">
                    <v-btn icon @click="dMostrarImagen = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="text-xs-center">
                    <img :src="dImagenSeleccionada" style="max-width: 100%; height: auto;" alt="Imagen del artículo">
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>
<script>

import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'
import SrvArticulos from '@/services/srv-articulos'

export default {
    components: {
        DatTextFieldCode
    },
    props: {
        pInformeComponente: {
            type: Object,
            required: true,
            default: false
        },
        pLimitDate: {
            type: Object,
            required: true,
            default: false
        }
    },
    data() {
        return {
            dOpenComponent: true,
            dInformeComponente: {},
            dLimitDate: {},
            dDatosFiltros: {},
            dHeadersTable: [],
            dDatosTabla: [],
            dPaginationSubArtOc: { 'sortBy': 'producto', 'descending': false, 'rowsPerPage': 5, 'page': 1 },
            dPaginationSubArt: { 'sortBy': 'cantidadLote', 'descending': true, 'rowsPerPage': 5, 'page': 1 },
            currentArticulo: '',
            dTotalSubArtItems: 0,
            dTotalSubArtOcItems: 0,
            dHeadersSubArtTabla: [],
            dHeadersSubArtOcTabla: [],
            dSubArtDatosTabla: [],
            dSubArtOcDatosTabla: [],
            dFormatDate: {
                'default': 'DD/MM/YYYY',
                'years': 'YYYY-MM-DD'
            },
            // 
            dFirstSortTable: 0,
            dFirstSortTableSubArt: 0,
            dFirstSortTableSubArtOc: 0,
            dRowsPerPageItemsArt: [5, 10, 25],
            dRowsPerPageItemsSubArt: [5, 10, 25],
            dRowsPerPageItemsSubArtOc: [5, 10, 25],
            dTotalItems: 0,
            dLoading: false,
            dPaginationArt: { 'sortBy': 'articulo', 'descending': false, 'rowsPerPage': 10, 'page': 1 },
            dIsOnPremise: localStorage.getItem('isOnPremise') === 'yes',
            dRequestCliente: { empresa: this.$store.getters.getAutenticacion.empresa },
            dMostrarImagen: false,
            dImagenSeleccionada: ''
        }
    },
    created() {
        this.fIniciarVariables()
    },
    mounted() {
        this.dInformeComponente = this.pInformeComponente
        this.dLimitDate = this.pLimitDate
    },
    methods: {
        fCerrarVentana() {
            this.$emit('close')
        },
        fIniciarVariables() {
            this.dHeadersTable = [
                { key: 'arrow', text: '', align: 'left', value: 'arrow', sortable: true },
                { key: 'imagen', text: '', align: 'left', value: 'imagen', sortable: true },
                { key: 'articulo', text: this.$t('articulo'), align: 'left', value: 'articulo', sortable: true },
                { key: 'denominacion', text: this.$t('descripcion'), align: 'left', value: 'denominacion', sortable: true },
                { key: 'stockDisponible', text: this.$t('stockDisponible'), align: 'left', value: 'stockDisponible', sortable: true },
                { key: 'unidadMedida', text: this.$t('uniMed'), align: 'left', value: 'unidadMedida', sortable: true },
                { key: 'stockPotencial', text: this.$t('stockPotencial'), align: 'left', value: 'stockPotencial', sortable: true },
                { key: 'ocMasReciente', text: this.$t('ocMasReciente'), align: 'left', value: 'ocMasReciente', sortable: true },
                { key: 'cantidadOC', text: this.$t('cantidad'), align: 'left', value: 'cantidadOC', sortable: true },
                { key: 'unidadMedidaOC', text: this.$t('uniMed'), align: 'left', value: 'unidadMedidaOC', sortable: true },
            ]
            this.dHeadersSubArtTabla = [
                { key: 'almacen', text: this.$t('almacen'), value: 'almacen', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'ubicacion', text: this.$t('ubicacion'), value: 'ubicacion', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'lote', text: this.$t('lote'), value: 'lote', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'cantidadExistente', text: this.$t('cantidadExistente'), value: 'cantidadExistente', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'uniMed', text: this.$t('uniMed'), value: 'uniMed', align: 'left', class: this.dClass, width: '500px' }
            ]
            this.dHeadersSubArtOcTabla = [
                { key: 'ordenCompra', text: this.$t('ordenCompra'), value: 'ordenCompra', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'fechaPrevista', text: this.$t('fechaPrevista'), value: 'fechaPrevista', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'cantidaPendiente', text: this.$t('cantidaPendiente'), value: 'cantidaPendiente', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'uniMed', text: this.$t('uniMed'), value: 'uniMed', align: 'left', class: this.dClass, width: '500px' }
            ]
        },
        fRespuestaCorrecta(response) {
            let finalValue = false;
            if (response.status === 200 && response.data.result !== 'ko' && (response || response.data !== undefined || response.data.dataRes.result !== undefined || response.data.dataRes.result !== null)) {
                finalValue = true
            }
            return finalValue
        },
        fBuscar() {
            const auth = this.$store.getters.getAutenticacion;
            const payload = {
                tira: auth.tira,
                usuario: this.$store.getters.getAutenticacion.usuario,
                empresa: this.$store.getters.getAutenticacion.empresa,
                search: this.dDatosFiltros.search || '',
                offset: this.dPaginationArt.rowsPerPage * (this.dPaginationArt.page - 1) + 1,
                numRows: this.dPaginationArt.rowsPerPage,
                orderBy: this.dPaginationArt.sortBy,
                order: this.dPaginationArt.descending ? 'DESC' : 'ASC'

            }
            this.dDatosTabla = [];
            this.dLoading = true
            try {
                SrvArticulos.stockOrdenCompra(payload).then((response) => {
                    if (!this.fRespuestaCorrecta(response)) {
                        this.dLoading = false
                        this.$emit('alert', response.data.errorMsg.message || `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`)
                        return
                    }
                    const datos = response.data.dataRes;
                    // 
                    if (Array.isArray(datos)) {
                        datos.forEach(item => {
                            this.dDatosTabla.push({
                                "imagen": '',
                                "articulo": item.articulo,
                                "denominacion": item.denominacion,
                                "stockDisponible": item.stockDisponible || 0,
                                "unidadMedida": item.unidadMedida || '-',
                                "stockPotencial": item.stockPotencial || 0,
                                "fechaOC": (item.fechaOC ? this.$moment(item.fechaOC, this.dFormatDate.years).format(this.dFormatDate.default) : '-'),
                                "cantidadOC": item.cantidadOC || 0,
                                "unidadMedidaOC": item.unidadMedidaOC || '-'
                            });
                        });
                    }
                    this.dTotalItems = response.data.numReg
                    this.dLoading = false
                    this.$refs.search.focus();

                }).then(() => {
                    this.dDatosTabla.forEach(item => {
                        const payload = {
                            tira: auth.tira,
                            empresa: this.$store.getters.getAutenticacion.empresa,
                            producto: item.articulo,
                        }
                        SrvArticulos.getUrlImgArt(payload).then((response) => {
                            console.log('response', response.data);

                            if (response.data && response.data.dataRes && response.data.dataRes.urlImagen) {
                                item.imagen = response.data.dataRes.urlImagen;
                            }
                            else {
                                item.imagen = '-'
                            }
                        });
                    })
                });
            } catch (error) {
                this.dLoading = false;
                this.$emit('alert', `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`)
            }
        },
        fGetLotesArticulos(props) {
            props.expanded = !props.expanded;
            if (!props.expanded) {
                this.currentArticulo = null;
                this.dSubArtDatosTabla = [];
                this.dSubArtOcDatosTabla = [];
                this.dTotalSubArtItems = 0;
                this.dTotalSubArtOcItems = 0;
                return;
            }

            this.currentArticulo = props;
            this.dPaginationSubArt.page = 1;
            this.dPaginationSubArtOc.page = 1;
            this.dFirstSortTableSubArt = 0;
            this.dFirstSortTableSubArtOc = 0;
            this.fCargaLotes();
            this.fCargaOrdenesCompra();
        },
        fCargaLotes() {
            if (!this.currentArticulo) {
                return;
            }

            this.dLoading = true;
            const payload = {
                tira: this.$store.getters.getAutenticacion.tira,
                empresa: this.$store.getters.getAutenticacion.empresa,
                articulo: this.currentArticulo.item.articulo,
                offset: this.dPaginationSubArt.rowsPerPage * (this.dPaginationSubArt.page - 1) + 1,
                numRows: this.dPaginationSubArt.rowsPerPage,
                orderBy: this.dPaginationSubArt.sortBy,
                order: this.dPaginationSubArt.descending ? 'DESC' : 'ASC'
            };

            SrvArticulos.stockCantidadExistente(payload)
                .then(response => {
                    this.dLoading = false;
                    if (!this.fRespuestaCorrecta(response)) {
                        this.$emit(
                            'alert',
                            response.data.errorMsg.message ||
                            `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`
                        );
                        return;
                    }

                    this.dTotalSubArtItems = response.data.numReg || 0;
                    this.dSubArtDatosTabla = (response.data.dataRes || []).map(item => ({
                        almacen: item.almacen,
                        ubicacion: item.ubicacion,
                        lote: item.lote,
                        cantidadLote: item.cantidadLote || 0,
                        unidadMedida: item.unidadMedida || '-'
                    }));

                })
                .catch(() => {
                    this.dLoading = false;
                    this.$emit('alert', `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`);
                });
        },
        fCargaOrdenesCompra() {
            if (!this.currentArticulo) {
                return;
            }

            this.dLoading = true;
            const payload = {
                tira: this.$store.getters.getAutenticacion.tira,
                empresa: this.$store.getters.getAutenticacion.empresa,
                codigoArticulo: this.currentArticulo.item.articulo,
                offset: this.dPaginationSubArtOc.rowsPerPage * (this.dPaginationSubArtOc.page - 1) + 1,
                numRows: this.dPaginationSubArtOc.rowsPerPage,
            };
            SrvArticulos.getProximasRecepcionesOCProd(payload).then(response => {
                this.dLoading = false;
                if (!this.fRespuestaCorrecta(response)) {
                    this.$emit(
                        'alert',
                        response.data.errorMsg.message ||
                        `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`
                    );
                    return;
                }

                this.dTotalSubArtOcItems = response.data.numReg || 0;
                this.dSubArtOcDatosTabla = (response.data.dataRes || []).map(item => ({
                    ordenCompra: item.ordenCompra,
                    fechaEntrega: (item.fechaEntrega ? this.$moment(item.fechaEntrega, this.dFormatDate.years).format(this.dFormatDate.default) : '-'),
                    cantidadPedida: item.cantidadPedida,
                    unidadMedidaUMP: item.unidadMedidaUMP || '-'
                }));
            })
                .catch(() => {
                    this.dLoading = false;
                    this.$emit('alert', `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`);
                });
        },
        fCambiaOrden(header, dPagination) {
            if (header.sortable) {
                const column = header.value
                dPagination.page = 1
                if (dPagination.sortBy === column) {
                    dPagination.descending = !dPagination.descending
                } else {
                    dPagination.sortBy = column
                    dPagination.descending = false
                }
            }
        },
        fMostrarImagenGrande(imagenUrl) {
            this.dImagenSeleccionada = imagenUrl;
            this.dMostrarImagen = true;
        }
    }, watch: {
        dPaginationArt: {
            handler(newPage, oldPage) {
                if (this.dFirstSortTable > 0) {
                    this.fBuscar()
                }
                this.dFirstSortTable++
            },
            deep: true
        },
        dPaginationSubArt: {
            handler(newPage, oldPage) {
                if (!this.currentArticulo) {
                    return;
                }
                if (newPage === oldPage) {
                    return;
                }
                this.dFirstSortTableSubArt++;
                if (this.dFirstSortTableSubArt > 0) {
                    this.fCargaLotes();
                }
            },
            deep: true
        },
        dPaginationSubArtOc: {
            handler(newPage, oldPage) {
                if (!this.currentArticulo) {
                    return;
                }
                if (newPage === oldPage) {
                    return;
                }
                this.dFirstSortTableSubArtOc++;
                if (this.dFirstSortTableSubArtOc > 0) {
                    this.fCargaOrdenesCompra();
                }
            },
            deep: true
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/StockArticulos/ShpStockArticulos.vue